export default {
  categorytype: 'Type de catégories',
  categorytypes: 'Types de catégories',
  verbose_categorytype: 'un type de catégorie',

  select_categorytypes: 'Sélectionner un type de catégories',
};
